import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Dimmer } from "../../spinner";
import { Mensaje } from "../../mensajes2";
import axios from "axios";
import moment from "moment";
import { validaSoloNumero } from "../../../util/varios";
import CatalogoComercio from "../../../catalogos/catalogoComercio";
import { crearBitacora } from "../../../hooks/bitacora";
export const FrmImpCertMantenimiento = (props) => {
  const op = require("../../../modulos/datos");
  const token = localStorage.getItem("jwtToken");
  const anioactu = parseInt(localStorage.getItem("anioactu"));
  const fechaActual = new Date().toISOString().split("T")[0];
  const siguienteAnio = anioactu || new Date().getFullYear();
  const fechaVenci = `${siguienteAnio}-12-31`;
  const [fechaVencimiento, setFechaVencimiento] = useState(fechaVenci);
  const [fechaEmision, setFechaEmision] = useState(fechaActual);
  const [mostrarCatalogo, setMostrarCatalogo] = useState(false);
  const [loading, setLoading] = useState(false);
  const [poseeLic, setPoseeLic] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [body, setBody] = useState({
    tipoLicencia: "",
    codigo: "",
    licencia: "",
    numLicenciaActual: "",
    numLicenciaNueva: "",
    fechaInscripcion: "",
    rif: "",
    denominacionComercial: "",
    direccion: "",
    numSectorCatastral: "",
    numCuenta: "",
    rifProp: "",
    nomProp: "",
    direcProp: "",
    numFactura: "",
  });
  const buscarComercio = async (idComercio) => {
    try {
      setLoading(false);
      const campos = `
        c.idcomercio,
        c.nombre,
        c.rif,
        c.direccion,
        p.cedula as cedula_repre, 
        p.direccion as direccion_repre, 
        (p.nombres || ' ' || p.apellidos ) AS nombre_repre
      `;
      const tabla = `
      comercio c
      inner join persona p on c.reprelegal = p.cedula
      `;
      const nomid = "c.idcomercio";
      const condic = `c.idcomercio = ${idComercio}`;
      const endpoint = `${op.conexion}/api/consulta/modelicondi?campos=${campos}&id=${idComercio}&nomtab=${tabla}&nomid=${nomid}&condic=${condic}`;
      const response = await axios.get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      });
      if (
        response.status === 200 &&
        response.data &&
        response.data.length > 0
      ) {
        const data = response.data[0];
        setBody((prev) => ({
          ...prev,
          ...data,
          numSectorCatastral: data.codigocatastral,
          fechaInscripcion: moment
            .utc(data.fechainscripcion)
            .format("DD/MM/YYYY"),
          codigo: data.idcomercio,
          numCuenta: data.cuenta,
          denominacionComercial: data.nombre,
          direccion: data.direccion,
          rifProp: data.cedula_repre,
          nomProp: data.nombre_repre,
          direcProp: data.direccion_repre,
        }));
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Informacion",
          texto: "Comercio no Encontrado",
          icono: "informacion",
        });
        setBody({
          tipoLicencia: "",
          codigo: "",
          licencia: "",
          numLicenciaActual: "",
          numLicenciaNueva: "",
          fechaInscripcion: "",
          rif: "",
          denominacionComercial: "",
          direccion: "",
          numSectorCatastral: "",
          numCuenta: "",
          rifProp: "",
          nomProp: "",
          direcProp: "",
        });
      }
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "ERROR",
        texto: "Error al Buscar el Comercio",
        icono: "error",
      });
    } finally {
      setLoading(false);
    }
  };
  const buscarUltimoNumLicencia = async () => {
    try {
      setLoading(true);
      const endpoint = `${op.conexion}/api/industria/ultimo-certificado-mantenimiento?anio=${anioactu}`;
      const response = await axios.get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      });
      if (response.status === 200 && response.data) {
        setBody((prev) => ({
          ...prev,
          numLicenciaNueva: response.data.ultimoCertificado,
        }));
      }
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "ERROR",
        texto: "Error al Buscar la Ultima Licencia",
        icono: "error",
      });
    } finally {
      setLoading(false);
    }
  };
  const buscarLicenciaComercio = async (idComercio) => {
    try {
      setLoading(true);
      const endpoint = `${op.conexion}/api/industria/existe-licencia-mantenimiento?idcomercio=${idComercio}&anio=${anioactu}`;
      const response = await axios.get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      });
      if (
        response.status === 200 &&
        response.data &&
        response.data.length > 0
      ) {
        const nrocertif = response.data[0].nrocertif;
        setBody((prev) => ({
          ...prev,
          numLicenciaNueva: nrocertif,
          numLicenciaActual: nrocertif,
        }));
        setPoseeLic(true);
      } else {
        buscarUltimoNumLicencia();
        setPoseeLic(false);
      }
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "ERROR",
        texto: "Error al Buscar la Licencia del Comercio",
        icono: "error",
      });
    } finally {
      setLoading(false);
    }
  };
  const guardarLicencia = async () => {
    try {
      setLoading(true);
      const endpoint = `${op.conexion}/api/industria/registrar-licencia-mantenimiento`;
      const response = await axios.post(
        endpoint,
        {
          nuLicencia: body.numLicenciaNueva,
          anio: anioactu,
          fechaValida: fechaEmision,
          fechaVence: fechaVencimiento,
          numFactura: body.numFactura,
          idComercio: body.codigo,
        },
        {
          headers: {
            "x-access-token": `${token}`,
            "Content-Type": "application/json",
          },
        },
      );
      if (response.status === 200) {
        await crearBitacora(
          "GUARDAR LICENCIA DE MANTENIMIENTO",
          "mant_licenciaxcomercio",
          body.numLicenciaNueva,
        );
        setMensaje({
          mostrar: true,
          titulo: "",
          texto: "Licencia Registrada Correctamente",
          icono: "exito",
        });
        generarReporte();
      }
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "ERROR",
        texto: "Error al Guardar la Licencia",
        icono: "error",
      });
    } finally {
      setLoading(false);
    }
  };
  const actualizarLicencia = async () => {
    try {
      setLoading(true);
      const endpoint = `${op.conexion}/api/industria/actualizar-licencia-mantenimiento`;
      const response = await axios.post(
        endpoint,
        {
          nuLicencia: body.numLicenciaNueva,
          anio: anioactu,
          fechaValida: fechaEmision,
          fechaVence: fechaVencimiento,
          numFactura: body.numFactura,
          idComercio: body.codigo,
        },
        {
          headers: {
            "x-access-token": `${token}`,
            "Content-Type": "application/json",
          },
        },
      );
      if (response.status === 200) {
        setMensaje({
          mostrar: true,
          titulo: "",
          texto: "Licencia Actualizada Correctamente",
          icono: "exito",
        });
        await crearBitacora(
          "Actualizar LICENCIA DE MANTENIMIENTO",
          "mant_licenciaxcomercio",
          body.numLicenciaNueva,
        );
        generarReporte();
      }
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "ERROR",
        texto: "Error al Actualizar la Licencia",
        icono: "error",
      });
    } finally {
      setLoading(false);
    }
  };
  const validarContribuyente = (event) => {
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        buscarComercio(event.target.value);
        buscarLicenciaComercio(event.target.value);
      }
    }
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setBody((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const validarCampos = async () => {
    try {
      if (!body.codigo) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: "No se ha Seleccionado Ningún Comercio",
          icono: "error",
        });
        return;
      }
      if (!body.numFactura) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: "No se ha Ingresado el N° de Factura",
          icono: "error",
        });
        return;
      }
      if (!poseeLic) {
        await guardarLicencia();
      } else {
        await actualizarLicencia();
      }
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: "Error Interno",
        icono: "error",
      });
    }
  };

  const generarReporte = async () => {
    try {
      const [anio, mes, diaNum] = fechaVencimiento.split("-");
      const mesNum = parseInt(mes);
      const nombresMeses = [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre",
      ];

      const nombreMes = nombresMeses[mesNum - 1];
      const dia = parseInt(diaNum);
      window.open(
        `${op.reportes}/actividadeconomica?reporte=CertMantComAlpaezQR&CONDICION=${body.codigo}&nrocertif=${body.numLicenciaNueva}&idcomercio=${body.codigo}&anio=${parseInt(anioactu)}&numfactura=${body.numFactura}&DIA=${dia}&MES=${nombreMes}&aniov=${anio}`,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
      );
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: "Error al Generar el Reporte",
        icono: "error",
      });
    } finally {
      blanquear();
    }
  };
  const blanquear = () => {
    setFechaVencimiento(fechaVenci);
    setFechaEmision(fechaActual);
    setMostrarCatalogo(false);
    setLoading(false);
    setPoseeLic(false);
    setMensaje({
      mostrar: false,
      titulo: "",
      texto: "",
      icono: "",
    });
    setBody({
      tipoLicencia: "",
      codigo: "",
      licencia: "",
      numLicenciaActual: "",
      numLicenciaNueva: "",
      fechaInscripcion: "",
      rif: "",
      denominacionComercial: "",
      direccion: "",
      numSectorCatastral: "",
      numCuenta: "",
      rifProp: "",
      nomProp: "",
      direcProp: "",
      numFactura: "",
    });
  };
  const salir = () => {
    props.onHideCancela();
  };
  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      onShow={() => {
        blanquear();
      }}
    >
      <Modal.Header className="azulGradiant px-4 py-2 text-uppercase">
        <h3 className="fs-4 fw-bold text-light m-0">
          Impresión de Certificado de Mantenimiento de Licencia IAE
        </h3>
        <button className="btn btn-sm bg-light" onClick={() => salir()}>
          <i className="fa fa-times"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex justify-content-between">
          <div className="col-md-3 row py-2">
            <div className="input-group input-group-sm col-md-12 p-0 m-0 mb-0">
              <span
                className="input-group-text text-uppercase"
                id="inputGroup-sizing-sm"
              >
                Nº de Factura:
              </span>
              <input
                type="text"
                className="form-control text-uppercase"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-sm"
                name="numFactura"
                maxLength={8}
                value={body.numFactura}
                onChange={handleChange}
              />
            </div>
          </div>
          <div className="col-md-3 row py-2">
            <div className="input-group input-group-sm col-md-12 p-0 m-0 mb-0">
              <span
                className="input-group-text text-uppercase"
                id="inputGroup-sizing-sm"
              >
                Nº de Licencia Actual:
              </span>
              <input
                type="text"
                className="form-control text-uppercase"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-sm"
                name="numLicenActual"
                disabled
                value={body.numLicenciaActual}
              />
            </div>
          </div>
          <div className="col-md-3 row py-2">
            <div className="input-group input-group-sm col-md-12 p-0 m-0 mb-0">
              <span
                className="input-group-text text-uppercase"
                id="inputGroup-sizing-sm"
              >
                Nº de Nueva Licencia:
              </span>
              <input
                type="text"
                className="form-control text-uppercase text-right"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-sm"
                name="numLicenNueva"
                disabled
                value={body.numLicenciaNueva}
              />
            </div>
          </div>
        </div>
        <fieldset className="row mb-2 border-azul row rounded mx-auto">
          <legend
            className="float-none w-auto fw-bold text-uppercase"
            style={{
              fontSize: "0.9rem",
            }}
          >
            Fechas
          </legend>
          <div className="d-flex justify-content-between">
            <div className="col-md-4 row mx-auto p-auto py-2">
              <div className="input-group input-group-sm col-md-12 p-0 m-0 mb-0">
                <span
                  className="input-group-text text-uppercase"
                  id="inputGroup-sizing-sm"
                >
                  Fecha de Emision:
                </span>
                <input
                  type="date"
                  className="form-control text-uppercase"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  name="fechaEmision"
                  max={fechaActual}
                  value={fechaEmision}
                  onChange={(e) => {
                    const { value } = e.target;
                    setFechaEmision(value);
                  }}
                />
              </div>
            </div>
            <div className="col-md-4 row mx-auto p-auto py-2">
              <div className="input-group input-group-sm col-md-12 p-0 m-0 mb-0">
                <span
                  className="input-group-text text-uppercase"
                  id="inputGroup-sizing-sm"
                >
                  Fecha de Vencimiento:
                </span>
                <input
                  type="date"
                  className="form-control text-uppercase"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  name="fechaVenci"
                  disabled
                  value={fechaVencimiento}
                  onChange={(e) => {
                    const { value } = e.target;
                    setFechaVencimiento(value);
                  }}
                />
              </div>
            </div>
          </div>
        </fieldset>
        <fieldset className="row mb-2 border-azul row rounded mx-auto">
          <legend
            className="float-none w-auto fw-bold text-uppercase"
            style={{
              fontSize: "0.9rem",
            }}
          >
            Informacion
          </legend>
          <div className="d-flex justify-content-between">
            <div className="col-md-2 row my-auto py-2">
              <div className="input-group input-group-sm col-md-12 p-0 m-0">
                <span
                  className="input-group-text text-uppercase"
                  id="inputGroup-sizing-sm"
                >
                  Código:
                </span>
                <input
                  type="text"
                  className="form-control text-uppercase"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  name="codigo"
                  onKeyUp={validarContribuyente}
                  onChange={handleChange}
                  value={body.codigo}
                />
                <button
                  onClick={() => setMostrarCatalogo(true)}
                  style={{ textAlign: "center", color: "white" }}
                  className="btn btn-sm btn-info"
                >
                  <i className="fas fa-search"></i>{" "}
                </button>
              </div>
            </div>
            <div className="col-md-2 row my-auto py-2">
              <div className="input-group input-group-sm col-md-12 p-0 m-0 mb-0">
                <span
                  className="input-group-text text-uppercase"
                  id="inputGroup-sizing-sm"
                >
                  RIF:
                </span>
                <input
                  type="text"
                  className="form-control text-uppercase"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  name="rif"
                  disabled
                  value={body.rif}
                />
              </div>
            </div>
            <div className="col-md-8 row my-auto py-2">
              <div className="input-group input-group-sm col-md-12 p-0 m-0 mb-0">
                <span
                  className="input-group-text text-uppercase"
                  id="inputGroup-sizing-sm"
                >
                  Denominación Comercial:
                </span>
                <input
                  type="text"
                  className="form-control text-uppercase"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  name="denominacion"
                  disabled
                  value={body.denominacionComercial}
                />
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-between">
            <div className="col-md-12 row my-auto py-2 px-0 mx-0">
              <div className="input-group input-group-sm col-md-12 p-0 m-0">
                <span
                  className="input-group-text text-uppercase"
                  id="inputGroup-sizing-sm"
                >
                  Dirección:
                </span>
                <textarea
                  type="text"
                  className="form-control text-uppercase"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  name="direccion"
                  disabled
                  style={{ height: 60 }}
                  value={body.direccion}
                />
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-between">
            <div className="col-md-6 row my-auto py-2">
              <div className="input-group input-group-sm col-md-12 p-0 m-0">
                <span
                  className="input-group-text text-uppercase"
                  id="inputGroup-sizing-sm"
                >
                  Sector Catastral N°:
                </span>
                <input
                  type="text"
                  className="form-control text-uppercase"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  name="direccion"
                  disabled
                  value={body.numSectorCatastral}
                />
              </div>
            </div>
            <div className="col-md-6 row my-auto py-2">
              <div className="input-group input-group-sm col-md-12 p-0 m-0">
                <span
                  className="input-group-text text-uppercase"
                  id="inputGroup-sizing-sm"
                >
                  N° de Cuenta:
                </span>
                <input
                  type="text"
                  className="form-control text-uppercase"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  name="direccion"
                  disabled
                  value={body.numCuenta}
                />
              </div>
            </div>
          </div>
        </fieldset>
        <fieldset className="row mb-2 border-azul row rounded mx-auto">
          <legend
            className="float-none w-auto fw-bold text-uppercase"
            style={{
              fontSize: "0.9rem",
            }}
          >
            Propietario
          </legend>
          <div className="d-flex justify-content-between">
            <div className="col-md-4 row my-auto py-2">
              <div className="input-group input-group-sm col-md-12 p-0 m-0">
                <span
                  className="input-group-text text-uppercase"
                  id="inputGroup-sizing-sm"
                >
                  Cédula/RIF Propietario:
                </span>
                <input
                  type="text"
                  className="form-control text-uppercase"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  name="direccion"
                  disabled
                  value={body.rifProp}
                />
              </div>
            </div>
            <div className="col-md-8 row my-auto py-2">
              <div className="input-group input-group-sm col-md-12 p-0 m-0">
                <span
                  className="input-group-text text-uppercase"
                  id="inputGroup-sizing-sm"
                >
                  Nombre Propietario:
                </span>
                <input
                  type="text"
                  className="form-control text-uppercase"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  name="direccion"
                  disabled
                  value={body.nomProp}
                />
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-between">
            <div className="col-md-12 row my-auto py-2">
              <div className="input-group input-group-sm col-md-12 p-0 m-0">
                <span
                  className="input-group-text text-uppercase"
                  id="inputGroup-sizing-sm"
                >
                  Direccion Propietario:
                </span>
                <textarea
                  type="text"
                  className="form-control text-uppercase"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  name="direccion"
                  disabled
                  style={{ height: 60 }}
                  value={body.direcProp}
                />
              </div>
            </div>
          </div>
        </fieldset>
      </Modal.Body>
      <Modal.Footer>
        <button
          onClick={() => validarCampos()}
          className="btn-sm rounded-pill btn btn-primary col-md-2"
        >
          <i className="fas fa-print"></i> Imprimir
        </button>
        <button
          onClick={() => blanquear()}
          className="btn-sm rounded-pill btn btn-danger col-md-2"
        >
          <i className="fas fa-window-close"></i> Cancelar
        </button>
        <button
          onClick={() => salir()}
          className="btn-sm rounded-pill btn btn-danger col-md-2"
        >
          <i className="fa fa-sign-out"></i> Salir
        </button>
      </Modal.Footer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          setMensaje({
            mostrar: false,
            titulo: "",
            texto: "",
            icono: "",
          });
        }}
      />
      <CatalogoComercio
        show={mostrarCatalogo}
        onHideCancelaCatCom={() => setMostrarCatalogo(false)}
        onHideAceptaCatCom={(idCome) => {
          buscarComercio(idCome);
          buscarLicenciaComercio(idCome);
        }}
      />
      <Dimmer active={loading} inverted />
    </Modal>
  );
};
